import { Button } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 220px;
`;

export const FilterButton = styled(Button)`
  min-width: 98px;
  border-radius: 2px;
`;

export const FormContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;
